import React from 'react';
import { Check, Zap, Wallet, Clock } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const services = [{
  name: 'Gestión de WhatsApp Business para negocios locales',
  price: '$15 a $50 USD',
  detail: 'por configuración'
}, {
  name: 'Redacción de publicaciones para Instagram y Facebook',
  price: '$10 a $35 USD',
  detail: 'por paquete'
}, {
  name: 'Transcripción de audios y videos a texto',
  price: '$3 a $25 USD',
  detail: 'por entrega'
}, {
  name: 'Atención al cliente por chat para tiendas online',
  price: '$5 a $60 USD',
  detail: 'por semana'
}, {
  name: 'Organización de archivos digitales y correos',
  price: '$15 a $50 USD',
  detail: 'por proyecto'
}, {
  name: 'Diseño básico de flyers y publicaciones en Canva',
  price: '$8 a $30 USD',
  detail: 'por diseño'
}];
const criteria = [{
  icon: <Zap className="w-5 h-5 text-[#ADFF2F]" data-id="element-208" />,
  text: 'Alta demanda comprobada hoy en LATAM'
}, {
  icon: <Wallet className="w-5 h-5 text-[#ADFF2F]" data-id="element-209" />,
  text: 'Sin inversión ni equipo especial'
}, {
  icon: <Clock className="w-5 h-5 text-[#ADFF2F]" data-id="element-210" />,
  text: 'Entrega en menos de 24 horas'
}];
export const Services = () => {
  return <section className="py-20 md:py-24 bg-dark" data-id="element-211">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-212">
        <FadeIn data-id="element-213">
          <div className="text-center mb-14" data-id="element-214">
            <span className="text-[#ADFF2F] font-bold tracking-[0.2em] uppercase text-sm mb-4 block" data-id="element-215">
              Los 6 servicios
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-white leading-tight" data-id="element-216">
              Los 6 servicios que enseña esta guía
            </h2>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-4 md:gap-5 mb-14" data-id="element-217">
          {services.map((service, i) => <FadeIn key={i} delay={i * 0.08} data-id="element-218">
              <div className="bg-[#111111] border border-white/10 rounded-xl p-5 md:p-6 h-full hover:border-[#ADFF2F]/40 transition-colors flex flex-col" data-id="element-219">
                <div className="flex items-start gap-4 mb-4 flex-1" data-id="element-220">
                  <div className="shrink-0 w-8 h-8 rounded-full bg-[#ADFF2F] flex items-center justify-center" data-id="element-221">
                    <Check className="w-5 h-5 text-black" strokeWidth={3} data-id="element-222" />
                  </div>
                  <p className="text-base md:text-lg text-gray-200 leading-snug font-sans m-0" data-id="element-223">
                    {service.name}
                  </p>
                </div>
                <div className="pl-12" data-id="element-224">
                  <div className="inline-flex items-baseline gap-2 bg-[#0a0a0a] border border-[#ADFF2F]/30 rounded-lg px-3 py-1.5" data-id="element-225">
                    <span className="text-[#ADFF2F] font-bold text-base md:text-lg font-display" data-id="element-226">
                      {service.price}
                    </span>
                    <span className="text-gray-500 text-xs font-sans" data-id="element-227">
                      {service.detail}
                    </span>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-228">
          <div className="bg-[#0a0a0a] border border-white/10 rounded-2xl p-6 md:p-8" data-id="element-229">
            <p className="text-center text-gray-400 mb-6 font-sans" data-id="element-230">
              Estos servicios fueron seleccionados por{' '}
              <span className="text-white font-semibold" data-id="element-231">3 criterios:</span>
            </p>
            <div className="grid sm:grid-cols-3 gap-4" data-id="element-232">
              {criteria.map((c, i) => <div key={i} className="flex items-center gap-3 bg-[#111111] border border-white/5 rounded-lg p-4" data-id="element-233">
                  <div className="shrink-0" data-id="element-234">{c.icon}</div>
                  <p className="text-sm md:text-base text-gray-200 font-sans m-0" data-id="element-235">
                    {c.text}
                  </p>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};